export enum ResearchType360 {
  InviteOptional = 0,
  InviteObligated = 1,
  InviteDisabled = 2,
}
